import type { Plugin } from "vue";
import ui from "@nuxt/ui/vue-plugin";
import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  routes: [],
  history: createWebHistory(),
});

export default {
  install(app) {
    app.use(router);
    app.use(ui);
  },
} as Plugin;
